import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { ActivityType } from '@debbie/common/dist/web-sockets/index.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import { Badge, TypingIndicator, UserPreview, CasePreview } from './index.js';
import Modal from './Modal.js';
import Table from './Table.js';
const ActiveUsers = () => {
    const selectedOwners = useSelector((s) => s.selectedOwners);
    const _activeUsers = useSelector((s) => s.activeUsers);
    const me = useSelector(selectMe);
    const [modalOpen, setModalOpen] = useState(false);
    const activeUsers = me &&
        Object.values(Object.entries(_activeUsers)
            .reduce((acc, t) => selectedOwners.length === 0 ||
            (t[0] && selectedOwners.includes(t[0]))
            ? acc.concat(t[1].map((u) => ({ ...u, tenantId: t[0] })))
            : acc, [])
            .reduce((acc, user) => ({
            ...acc,
            [user.id]: {
                user,
                activities: ((acc[user.id] && acc[user.id].activities) ||
                    []).concat(user.activities),
                origins: ((acc[user.id] && acc[user.id].origins) || []).concat(user.wsId),
            },
        }), {}))
            .filter(({ user }) => ![me.id].includes(user.id) && !user?.details?.isSystemAgent)
            .slice(0, 15);
    return (React.createElement(StyledActiveUsers, { onClick: () => setModalOpen(!modalOpen) },
        me &&
            activeUsers?.map(({ user, origins }) => (React.createElement(ActiveUser, { className: origins.length > 1 ? 'stack' : '', key: user.id },
                React.createElement("div", { className: "active-user-tooltips" },
                    React.createElement("div", { className: "typing-indicator" },
                        React.createElement(TypingIndicator, { writing: !!user.activities.find((a) => [
                                ActivityType.WRITINGCLIENTNOTE,
                                ActivityType.WRITINGDEBTORNOTE,
                            ].includes(a.type)) }))),
                React.createElement(UserPreview, { tooltipToLeft: true, user: {
                        firstName: user.firstName,
                        id: user.id,
                        lastName: user.lastName,
                        role: user.role,
                    }, style: { marginRight: '-11px' } })))),
        modalOpen && (React.createElement(Modal, { maxWidth: "600px", onToggle: () => setModalOpen(!modalOpen) },
            React.createElement("br", null),
            React.createElement(Table, { zebra: true }, me &&
                activeUsers?.map(({ user, origins }) => (React.createElement("tr", { key: user.id },
                    React.createElement("td", null,
                        React.createElement(UserPreview, { user: {
                                firstName: user.firstName,
                                id: user.id,
                                lastName: user.lastName,
                                role: user.role,
                            } }),
                        ' ',
                        user.firstName,
                        " ",
                        user.lastName),
                    React.createElement("td", null,
                        React.createElement(TypingIndicator, { writing: !!user.activities.find((a) => [
                                ActivityType.WRITINGCLIENTNOTE,
                                ActivityType.WRITINGDEBTORNOTE,
                            ].includes(a.type)) })),
                    React.createElement("td", { style: { textAlign: 'right' } }, user.activities.map((activity) => (React.createElement(React.Fragment, { key: `${activity.type}${activity.handle}${user.id}` }, activity.type === ActivityType.WATCHINGCASE ? (React.createElement("div", { className: "case-preview" },
                        React.createElement(CasePreview, { caseId: activity.handle }))) : [
                        ActivityType.WRITINGCLIENTNOTE,
                        ActivityType.WRITINGDEBTORNOTE,
                    ].includes(activity.type) ? null : (React.createElement(Badge, { theme: "black" }, activity.type))))))))))))));
};
export default ActiveUsers;
const StyledActiveUsers = styled.div `
  display: inline-block;
  padding-right: 25px;
  cursor: pointer;
  margin-top: -4px;
`;
const ActiveUser = styled.div `
  display: inline-block;
  position: relative;

  .active-user-tooltips {
    position: absolute;
    bottom: 21px;
    left: -5px;
    min-width: 100px;

    .typing-indicator {
      margin-top: 5px;
    }

    .case-preview {
      margin-top: 5px;
      font-size: 0.5em;
    }
  }

  &.stack::before,
  &.stack::after {
    /* Add shadow to distinguish sheets from one another */
    box-shadow: 2px 1px 1px rgba(0, 0, 0, 0.15);
  }

  &.stack::before,
  &.stack::after {
    content: '';
    position: absolute;
    width: 27px;
    height: 27px;
    background-color: #9e9e9e;
    border-radius: 100%;
  }

  /* Second sheet of paper */
  &.stack::before {
    left: 1px;
    top: 2px;
    z-index: -1;
  }

  /* Third sheet of paper */
  &.stack::after {
    left: 2px;
    top: 4px;
    z-index: -2;
  }

  &:hover {
    z-index: 1;
  }
`;
//# sourceMappingURL=ActiveUsers.js.map